<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="EPI">Now that my ladder’s gone,</p>
<p class="EPI">I must lie down where all the ladders start,</p>
<p class="EPI">In the foul rag-and-bone shop of the heart.</p>
<p class="EPS"><span class="ePub-B">—W. B. YEATS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?3015759d